"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./..");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FooterWithButtons = require("./FooterWithButtons.styled");
var FooterWithButtons = function FooterWithButtons(_ref) {
  var disabled = _ref.disabled,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    createButtonText = _ref.createButtonText;
  return _react["default"].createElement("div", {
    className: "float-end"
  }, _react["default"].createElement(_.Button, {
    "data-testid": "submitButton",
    color: "primary",
    disabled: disabled,
    onClick: function onClick(e) {
      e.preventDefault();
      onSubmit();
    }
  }, createButtonText), ' ', _react["default"].createElement(_FooterWithButtons.StyledCancelButton, {
    "data-testid": "cancelButton",
    color: "light",
    variant: "outlined",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    }
  }, "Cancel"));
};
FooterWithButtons.propTypes = {
  onCancel: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  createButtonText: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = FooterWithButtons;